import Group from './Group'
import Input from './Input'
import Label from './Label'

const Checkbox = { Group, Input, Label }

// Proper display names are necessary to generate correct code snippets in stories
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
Checkbox.Group.displayName = 'Checkbox.Group'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
Checkbox.Input.displayName = 'Checkbox.Input'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
Checkbox.Label.displayName = 'Checkbox.Label'

export default Checkbox
